<template>
  <dp-container>
    <div class="pt-5">
      <DpPetTrackingDeviceAddToOrder :api-token="userToken" :api-url="apiUrl" />
    </div>
  </dp-container>
</template>

<script>
import { mapState } from 'vuex';
import { DpContainer, DpPetTrackingDeviceAddToOrder } from '@docupet/component-library';
export default {
  name: 'AddToOrder',
  components: { DpPetTrackingDeviceAddToOrder, DpContainer },
  computed: {
    ...mapState({
      userToken: (state) => state.token,
      state: (state) => state,
      apiUrl: () => global.API_URL || process.env.VUE_APP_API_URL,
    }),
  },
};
</script>

<style lang="scss"></style>
